<input
  type="file"
  [multiple]="multiple"
  [accept]="allowedMimeTypes"
  style="display: none"
  #fileInput
  (change)="onFilesSelected($event); fileInput.value = ''"
  />

<div class="grid">
  @for (upload of fileUploadSession.uploads; track upload) {
    <div>{{ upload.fileName }}</div>
    <mat-progress-bar
      [value]="upload.uploadProgressPercent$ | async"
      mode="determinate"
      [color]="getColor(upload)"
    ></mat-progress-bar>
    <div>{{ upload.uploadProgressPercent$ | async }}%</div>
    <div>
      @if (upload.isRemovable) {
        <mat-icon>delete</mat-icon>
      }
    </div>
  }
</div>
@if (multiple || !fileUploadSession.uploads.length) {
  <div>
    @switch (displayStyle) {
      @case ('dropZone') {
        <div
          class="dropzone"
          [class.disabled]="disabled"
          (dragenter)="onFileDrag($event, true)"
          (dragover)="onFileDrag($event, true)"
          (dragleave)="onFileDrag($event, false)"
          (drop)="onFileDrop($event)"
          [class.draggingOver]="this.draggingOverDropzone"
          (click)="disabled ? null : fileInput.click()"
          >
          <ng-container *ngTemplateOutlet="ngContent" />
        </div>
      }
      @case ('button') {
        @switch (buttonType) {
          @case ('mat-button') {
            <button
              mat-button
              [disabled]="disabled"
              [color]="color"
              (click)="fileInput.click()"
              >
              @if (buttonIcon) {
                <mat-icon>{{ buttonIcon }}</mat-icon
                  >
                  }<ng-container *ngTemplateOutlet="ngContent" />
                </button>
              }
              @case ('mat-raised-button') {
                <button
                  mat-raised-button
                  [disabled]="disabled"
                  [color]="color"
                  (click)="fileInput.click()"
                  >
                  @if (buttonIcon) {
                    <mat-icon>{{ buttonIcon }}</mat-icon
                      >
                      }<ng-container *ngTemplateOutlet="ngContent" />
                    </button>
                  }
                  @case ('mat-stroked-button') {
                    <button
                      mat-stroked-button
                      [disabled]="disabled"
                      [color]="color"
                      (click)="fileInput.click()"
                      >
                      @if (buttonIcon) {
                        <mat-icon>{{ buttonIcon }}</mat-icon
                          >
                          }<ng-container *ngTemplateOutlet="ngContent" />
                        </button>
                      }
                      @case ('mat-flat-button') {
                        <button
                          mat-flat-button
                          [disabled]="disabled"
                          [color]="color"
                          (click)="fileInput.click()"
                          >
                          @if (buttonIcon) {
                            <mat-icon>{{ buttonIcon }}</mat-icon
                              >
                              }<ng-container *ngTemplateOutlet="ngContent" />
                            </button>
                          }
                          @case ('mat-icon-button') {
                            <button
                              mat-icon-button
                              [disabled]="disabled"
                              [color]="color"
                              (click)="fileInput.click()"
                              >
                              @if (buttonIcon) {
                                <mat-icon>{{ buttonIcon }}</mat-icon
                                  >
                                  }<ng-container *ngTemplateOutlet="ngContent" />
                                </button>
                              }
                              @case ('mat-icon-button mat-medium-icon-button') {
                                <button
                                  mat-icon-button
                                  mat-medium-icon-button
                                  [disabled]="disabled"
                                  [color]="color"
                                  (click)="fileInput.click()"
                                  >
                                  @if (buttonIcon) {
                                    <mat-icon>{{ buttonIcon }}</mat-icon
                                      >
                                      }<ng-container *ngTemplateOutlet="ngContent" />
                                    </button>
                                  }
                                  @case ('mat-icon-button mat-small-icon-button') {
                                    <button
                                      mat-icon-button
                                      mat-small-icon-button
                                      [disabled]="disabled"
                                      [color]="color"
                                      (click)="fileInput.click()"
                                      >
                                      @if (buttonIcon) {
                                        <mat-icon>{{ buttonIcon }}</mat-icon
                                          >
                                          }<ng-container *ngTemplateOutlet="ngContent" />
                                        </button>
                                      }
                                      @case ('mat-icon-button mat-tiny-icon-button') {
                                        <button
                                          mat-icon-button
                                          mat-tiny-icon-button
                                          [disabled]="disabled"
                                          [color]="color"
                                          (click)="fileInput.click()"
                                          >
                                          @if (buttonIcon) {
                                            <mat-icon>{{ buttonIcon }}</mat-icon
                                              >
                                              }<ng-container *ngTemplateOutlet="ngContent" />
                                            </button>
                                          }
                                          @case ('mat-fab') {
                                            <button
                                              mat-fab
                                              [disabled]="disabled"
                                              [color]="color"
                                              (click)="fileInput.click()"
                                              >
                                              @if (buttonIcon) {
                                                <mat-icon>{{ buttonIcon }}</mat-icon
                                                  >
                                                  }<ng-container *ngTemplateOutlet="ngContent" />
                                                </button>
                                              }
                                              @case ('mat-mini-fab') {
                                                <button
                                                  mat-mini-fab
                                                  [disabled]="disabled"
                                                  [color]="color"
                                                  (click)="fileInput.click()"
                                                  >
                                                  @if (buttonIcon) {
                                                    <mat-icon>{{ buttonIcon }}</mat-icon
                                                      >
                                                      }<ng-container *ngTemplateOutlet="ngContent" />
                                                    </button>
                                                  }
                                                  @case ('mat-fab extended') {
                                                    <button
                                                      mat-fab
                                                      extended
                                                      [disabled]="disabled"
                                                      [color]="color"
                                                      (click)="fileInput.click()"
                                                      >
                                                      @if (buttonIcon) {
                                                        <mat-icon>{{ buttonIcon }}</mat-icon
                                                          >
                                                          }<ng-container *ngTemplateOutlet="ngContent" />
                                                        </button>
                                                      }
                                                    }
                                                  }
                                                }
                                              </div>
                                            }

                                            <ng-template #ngContent>
                                              <ng-content />
                                            </ng-template>
